import { render } from "./RoleEdit.vue?vue&type=template&id=1eb2bb5d&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"

import "./RoleEdit.vue?vue&type=style&index=0&id=1eb2bb5d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb2bb5d"]])

export default __exports__